"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClass = addClass;
exports.byteLength = byteLength;
exports.checkType = checkType;
exports.cleanArray = cleanArray;
exports.cloneDeep = cloneDeep;
exports.createUniqueString = createUniqueString;
exports.debounce = debounce;
exports.deepClone = deepClone;
exports.formatDateTime = formatDateTime;
exports.formatTime = formatTime;
exports.generateUUID = generateUUID;
exports.getDeploy = getDeploy;
exports.getQueryObject = getQueryObject;
exports.getTime = getTime;
exports.hasClass = hasClass;
exports.html2Text = html2Text;
exports.load = load;
exports.objectMerge = objectMerge;
exports.param = param;
exports.param2Obj = param2Obj;
exports.parseTime = parseTime;
exports.passwordStrength = passwordStrength;
exports.removeClass = removeClass;
exports.resetLayout = resetLayout;
exports.showName = showName;
exports.toggleClass = toggleClass;
exports.uniqueArr = uniqueArr;
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
var _typeof2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
var Vue = require("vue");
function parseTime(time, cFormat) {
  // console.log('进入这里了111', time)
  if (arguments.length === 0) {
    return null;
  }
  if (!time) {
    return null;
  }
  var format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  var date;
  if ((0, _typeof2.default)(time) === "object" && time !== null) {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    if (time === null) return null;
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}
// parseTime()

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + "月" + d.getDate() + "日" + d.getHours() + "时" + d.getMinutes() + "分";
  }
}

/**
 * utc时间制格式转化
 */
function formatDateTime(utc) {
  var date = new Date(utc);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  var second = date.getSeconds();
  second = second < 10 ? "0" + second : second;
  return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
}

/**
 * @param {string} url
 * @returns {Object}
 */
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf("?") + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
function param(json) {
  if (!json) return "";
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return "";
    return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
  })).join("&");
}

/**
 * @param {string} url
 * @returns {Object}
 */
function param2Obj(url) {
  var search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, " ") + '"}');
}

/**
 * @param {string} val
 * @returns {string}
 */
function html2Text(val) {
  var div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
function objectMerge(target, source) {
  if ((0, _typeof2.default)(target) !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if ((0, _typeof2.default)(sourceProperty) === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var _later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(_later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(_later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepClone(source) {
  if (!source && (0, _typeof2.default)(source) !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && (0, _typeof2.default)(source[keys]) === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}
function cloneDeep(obj) {
  var objClone = Array.isArray(obj) ? [] : {};
  if (obj && (0, _typeof2.default)(obj) === "object") {
    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] && (0, _typeof2.default)(obj[key]) === "object") {
          objClone[key] = cloneDeep(obj[key]);
        } else {
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
function createUniqueString() {
  var timestamp = +new Date() + "";
  var randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

/**
 * get UUID form hottable
 * @return {String} string
 */
function generateUUID() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
}

/**
 * check password Strength
 * @return {String} string
 */
function passwordStrength(str) {
  var _color = ["red", "gray", "orange", "green"];
  var msgs = ["密码太短", "弱", "中", "强"];
  var msgsEn = ['Too Short', 'Weak', 'Medium', 'Strong'];
  var _strength = 0;
  var _v = str.replace(/^(\s|\u00a0)+|(\s|\u00a0)+$/g, "");
  var _vL = _v.length;
  var i = 0;
  var passwordStrengthText = null;
  var passwordStrengthColor = null;
  var passwordStrengthTextEn = null;
  var charStrength = function charStrength(char) {
    // 计算单个字符强度
    if (char >= 48 && char <= 57) {
      // 数字
      return 1;
    }
    if (char >= 97 && char <= 122) {
      // 小写
      return 2;
    } else {
      return 3; // 特殊字符
    }
  };
  if (_vL < 8) {
    // 计算模式
    passwordStrengthText = msgs[0];
    passwordStrengthColor = _color[0];
    passwordStrengthTextEn = msgsEn[0];
  } else {
    for (; i < _vL; i++) {
      // 遍历字符
      _strength += charStrength(_v.toLocaleLowerCase().charCodeAt(i));
    }
    if (_strength < 10) {
      // 强度小于10
      passwordStrengthText = msgs[1];
      passwordStrengthColor = _color[1];
      passwordStrengthTextEn = msgsEn[1];
    }
    if (_strength >= 10 && _strength < 15) {
      passwordStrengthText = msgs[2];
      passwordStrengthColor = _color[2];
      passwordStrengthTextEn = msgsEn[2];
    }
    if (_strength >= 15) {
      passwordStrengthText = msgs[3];
      passwordStrengthColor = _color[3];
      passwordStrengthTextEn = msgsEn[3];
    }
  }
  return {
    passwordStrengthText: passwordStrengthText,
    passwordStrengthColor: passwordStrengthColor,
    passwordStrengthTextEn: passwordStrengthTextEn
  };
}

/**
 * checkType  判断字符类型
 * checkType().isString(content)
 * @return {boolean} true or false
 */
function checkType() {
  var _curring = function curring(fn) {
    var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var len = fn.length;
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      arr = arr.concat(args);
      if (arr.length < len) {
        return _curring(fn, arr);
      }
      return fn.apply(void 0, (0, _toConsumableArray2.default)(arr));
    };
  };
  var checkType = function checkType(type, content) {
    return Object.prototype.toString.call(content) === "[object ".concat(type, "]");
  };
  var types = ["Number", "String", "Boolean", "Function", "Date", "Array", "RegExp"];
  var utils = {};
  types.forEach(function (type) {
    utils["is" + type] = _curring(checkType)(type);
  });
  return utils;
}
/**
 * getDeploy 判断当前的环境
 */
function getDeploy() {
  return process.env.VUE_APP_BASE_DEPLOY;
}

/**
 * 处理blob 转json
 * @param {Object} result
 * @return {Object} json
 */
// export function resultProcess(result) {
//   const { data, config } = result
//   let resultData = null
//   return new Promise((resolve, reject) => {
//     if (config.responseType === 'blob') {
//       const reader = new FileReader()
//       reader.readAsText(data, 'utf-8')
//       reader.onload = function() {
//         resultData = JSON.parse(reader.result)
//         resolve(resultData)
//       }
//     } else {
//       resolve(result.data)
//     }
//   })
// }
/**
 * 显示遮罩层
 * @return {Object} 返回一个对象调用对象的close方法可以关闭遮罩层
 */
function load() {
  return Vue.default.prototype.$loading({
    lock: true,
    spinner: "el-icon-loading-new",
    background: "rgba(255, 255, 255, 0.6)",
    target: document.querySelector(".gl-dialogPopMain")
  });
}

/**
 * 重置表格宽度高度
 * @param {Object} 需要传入hot-table的ref
 * @return {Object} 返回一个可以重置表格宽度高度的方法
 */
function resetLayout(ref, widthFlag, heightFlag) {
  return Handsontable.helper.debounce(function () {
    var parentElement = ref.$el.parentElement;
    var parentWidth = ref.getFinalWidth(parentElement);
    var parentHeight = ref.getFinalHeight(parentElement);
    var currentWidth = ref.$el.clientWidth;
    var currentHeight = ref.$el.clientHeight;
    var sizeObj = {};
    if (widthFlag && parentWidth !== currentWidth) {
      sizeObj.width = parentWidth;
    }
    if (heightFlag && parentHeight !== currentHeight) {
      sizeObj.height = parentHeight;
    }
    ref.hotInstance.updateSettings(sizeObj);
  }, 0);
}
function showName(arr, id) {
  var _this = this;
  if (arr instanceof Array) {
    var label = "";
    arr.some(function (item) {
      if (item.codeValue === id) {
        label = _this.language === "zh" ? item.displayValueCn : item.displayValue;
        return true;
      }
    });
    return label;
  }
}